import React from 'react'

const Request = () => {
  return (
    <div className='font-main'>
      <header className='h-52 bg-black flex items-center justify-center'>
    <div className='flex-col justify-center items-center'>
            <h1 className='text-white text-8xl text-center'>Request/Add</h1>
    <br />
    <h3 className='text-white text-2xl text-center'>All our forms are processed with backend logic for automation. If forms are not processed within a week. Please contact nanditarajkumar@gmail.com.</h3>
  </div>
      </header>
      <div className='flex flex-wrap w-[100%]'>
        <div className='w-1/2 min-w-80'>
          <iframe className='w-[100%] h-[1000px]' src="https://docs.google.com/forms/d/e/1FAIpQLSdTUiN8yJ1k5fA0CoiA5x6Q7lSvc1nI09bIx-HaodScm5u7mQ/viewform?embedded=true">Loading…</iframe>
        </div>
        <div className='w-1/2 min-w-80'>
          <iframe className='w-[100%] h-[1000px]' src="https://docs.google.com/forms/d/e/1FAIpQLSeQ6q9DSF-9D2qYHy4TAcdJjwK0jzQNBUrREu8YtPb-Tx1FyA/viewform?embedded=true">Loading…</iframe>
        </div>

      </div>
      
    </div>
  )
}

export default Request
